<template>
  <div class="wrapper cell grid-y align-justify padding-xs">
    <div class="card-text cell">
      <div ref="offerNameRef" class="offer-name large margin-bottom-xxs">
        {{ offerName }}
      </div>
      <div ref="offerDescRef" class="offer-desc small margin-bottom-xxs">
        {{ offerDesc }}
      </div>
    </div>
    <div>
      <div class="cell grid-x align-justify margin-bottom-xxs">
        <div class="card-text">
          <div v-if="offerExp" class="offer-expiry small">Ends: {{ offerExp }}</div>
        </div>
        <div class="promo small promo-links">
          <p v-if="offerCode.length" class="format-text promo-code" :class="OFFERPROMOS.promoColor">{{ OFFERPROMOS.promoCode }}: {{ offerCode }}</p>
          <p v-else class="format-text">
            {{ OFFERPROMOS.noPromoCode }}
          </p>
        </div>
      </div>
      <div class="cell grid-x align-justify">
        <div class="shop-now card-text">
          <a v-if="!autoProvisioned" class="link-sm" :href="getPromotionURL">
            {{ OFFERPROMOS.shopNow }}
          </a>
        </div>
        <div class="promo-links-exclusion">
          <p class="align-justify">
            <button v-if="exclusionContent.length" class="link-sm" @click.prevent="openExclusions">
              {{ OFFERPROMOS.exclusionDetails }}
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { fireTag } from '@vue-util/tagManager';
import { OFFERPROMOS } from 'config';
import useSlideout from '@/composables/useSlideout';

const { showSlideout } = useSlideout();

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
});

const offerName = props.offer?.offerName || '';
const offerDesc = props.offer?.offerDesc || '';
const autoProvisioned = props.offer?.autoProvisioned || false;
const offerExp = props.offer.offerExpDate
  ? new Date(props.offer?.offerExpDate).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  : null;
const offerCode = props.offer?.offerCode || '';
const exclusionContent = props.offer?.legalDisclaimer || '';

const getPromotionURL = computed(() => {
  const promotionUrl = props.offer?.promotionClickThoughUrl;
  if (promotionUrl) {
    const urlSeparator = promotionUrl.includes('?') ? '&' : '?';
    if (promotionUrl.startsWith('/')) {
      return `${promotionUrl}${urlSeparator}linklocation=pagecontent`;
    }
    if (!promotionUrl.startsWith('http') && !promotionUrl.startsWith('https')) {
      return `https://${promotionUrl}${urlSeparator}linklocation=pagecontent`;
    }
    return `${promotionUrl}${urlSeparator}linklocation=pagecontent`;
  }
  return OFFERPROMOS.viewAllUrl;
});

const openExclusions = () => {
  const component = import('./ExclusionContent');
  showSlideout('offers-slideout', OFFERPROMOS.exclusionDetailsSlideoutTitle, component, true, { exclusionContent });
  fireTag('link', {
    ...OFFERPROMOS.tag,
  });
};
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.wrapper {
  align-content: start;
  cursor: pointer;
  width: auto;
  min-height: rem-calc(208);
  max-height: rem-calc(368);
  overflow-y: auto;
  border: $gray-3-border;
}
</style>

<style lang="scss" brand="mcom" scoped>
.wrapper {
  border-radius: rem-calc(5);
}
</style>
